<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-record-information`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.8 22.975l4.243 4.243a2 2 0 010 2.829L32.591 43.498a2 2 0 01-1.42.586l-4.23-.014a2 2 0 01-1.993-1.993l-.014-4.23a2 2 0 01.586-1.42l13.452-13.452a2 2 0 012.828 0zM9 4h30a2 2 0 012 2v13h-4V8H11v32h10v4H9a2 2 0 01-2-2V6a2 2 0 012-2zm31.386 23.218L28.937 38.667l.005 1.41 1.41.004L41.8 28.632l-1.414-1.414zM24 25a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H16a1 1 0 01-1-1v-2a1 1 0 011-1h16z"/></svg>
</template>
<script>

export default {
  name: 'IconRecordInformation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
